import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Target, Users, Building, Briefcase } from "@/components/ds/icons";
import { PageHeader } from "@/components/ui/PageHeader";

export function Metas() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Definir Metas"
        subtitle="Sistema de objetivos y KPIs"
      />

      <div className="grid gap-6 md:grid-cols-2">
        <Card>
          <CardHeader>
            <div className="flex items-center gap-2">
              <Briefcase className="h-5 w-5 text-primary" />
              <CardTitle>Metas por Cargo</CardTitle>
            </div>
            <CardDescription>Objetivos asignados a roles específicos</CardDescription>
          </CardHeader>
          <CardContent className="space-y-3">
            {[
              { cargo: "Supervisor", meta: "1 ART diario", frecuencia: "Diaria", cumplimiento: 92 },
              { cargo: "Operador", meta: "Check de maquinaria", frecuencia: "Pre-turno", cumplimiento: 88 },
              { cargo: "Conductor", meta: "Inspección vehicular", frecuencia: "Diaria", cumplimiento: 95 },
            ].map((item, idx) => (
              <div key={idx} className="rounded-lg border p-3">
                <div className="flex items-start justify-between">
                  <div>
                    <p className="font-medium">{item.cargo}</p>
                    <p className="text-sm text-muted-foreground">{item.meta}</p>
                  </div>
                  <Badge variant="outline">{item.frecuencia}</Badge>
                </div>
                <div className="mt-2 flex items-center gap-2">
                  <div className="h-2 flex-1 rounded-full bg-secondary">
                    <div
                      className="h-2 rounded-full bg-primary"
                      style={{ width: `${item.cumplimiento}%` }}
                    />
                  </div>
                  <span className="text-sm font-medium">{item.cumplimiento}%</span>
                </div>
              </div>
            ))}
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <div className="flex items-center gap-2">
              <Users className="h-5 w-5 text-primary" />
              <CardTitle>Metas por Contratista</CardTitle>
            </div>
            <CardDescription>Objetivos de empresas colaboradoras</CardDescription>
          </CardHeader>
          <CardContent className="space-y-3">
            {[
              { contratista: "Servicios Industriales", meta: "100% EPP documentado", cumplimiento: 97 },
              { contratista: "Construcción y Obras", meta: "Capacitaciones mensuales", cumplimiento: 85 },
              { contratista: "Transportes del Norte", meta: "Checks vehiculares diarios", cumplimiento: 100 },
            ].map((item, idx) => (
              <div key={idx} className="rounded-lg border p-3">
                <div className="flex items-start justify-between">
                  <div>
                    <p className="font-medium">{item.contratista}</p>
                    <p className="text-sm text-muted-foreground">{item.meta}</p>
                  </div>
                </div>
                <div className="mt-2 flex items-center gap-2">
                  <div className="h-2 flex-1 rounded-full bg-secondary">
                    <div
                      className="h-2 rounded-full bg-primary"
                      style={{ width: `${item.cumplimiento}%` }}
                    />
                  </div>
                  <span className="text-sm font-medium">{item.cumplimiento}%</span>
                </div>
              </div>
            ))}
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <div className="flex items-center gap-2">
              <Target className="h-5 w-5 text-primary" />
              <CardTitle>Metas por Área</CardTitle>
            </div>
            <CardDescription>Objetivos por departamentos</CardDescription>
          </CardHeader>
          <CardContent className="space-y-3">
            {[
              { area: "Terreno A", meta: "80% cumplimiento documentación", cumplimiento: 94 },
              { area: "Operaciones", meta: "Cero incidentes mensuales", cumplimiento: 78 },
              { area: "Flota", meta: "100% vehículos con check diario", cumplimiento: 96 },
            ].map((item, idx) => (
              <div key={idx} className="rounded-lg border p-3">
                <div className="flex items-start justify-between">
                  <div>
                    <p className="font-medium">{item.area}</p>
                    <p className="text-sm text-muted-foreground">{item.meta}</p>
                  </div>
                </div>
                <div className="mt-2 flex items-center gap-2">
                  <div className="h-2 flex-1 rounded-full bg-secondary">
                    <div
                      className="h-2 rounded-full bg-primary"
                      style={{ width: `${item.cumplimiento}%` }}
                    />
                  </div>
                  <span className="text-sm font-medium">{item.cumplimiento}%</span>
                </div>
              </div>
            ))}
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <div className="flex items-center gap-2">
              <Building className="h-5 w-5 text-primary" />
              <CardTitle>Metas Internas</CardTitle>
            </div>
            <CardDescription>Objetivos de la empresa</CardDescription>
          </CardHeader>
          <CardContent className="space-y-3">
            {[
              { meta: "Digitalización 100% documentos", plazo: "Mensual", cumplimiento: 89 },
              { meta: "Respuesta < 24hrs", plazo: "Continuo", cumplimiento: 92 },
              { meta: "Capacitación trimestral", plazo: "Trimestral", cumplimiento: 100 },
            ].map((item, idx) => (
              <div key={idx} className="rounded-lg border p-3">
                <div className="flex items-start justify-between">
                  <div>
                    <p className="font-medium">{item.meta}</p>
                    <p className="text-sm text-muted-foreground">Plazo: {item.plazo}</p>
                  </div>
                </div>
                <div className="mt-2 flex items-center gap-2">
                  <div className="h-2 flex-1 rounded-full bg-secondary">
                    <div
                      className="h-2 rounded-full bg-primary"
                      style={{ width: `${item.cumplimiento}%` }}
                    />
                  </div>
                  <span className="text-sm font-medium">{item.cumplimiento}%</span>
                </div>
              </div>
            ))}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
